// Záměrně uvedeno v češtině, aby se zabránilo nedorozumění u nepřeložitelné právní terminologie.
export enum CzechContractType {
  /** Dohoda o provedení práce (DPP). */
  DohodaOProvedeniPrace = "dpp",
  /** Dohoda o pracovní činnosti (DPČ). */
  DohodaOPracovniCinnosti = "dpc",
  /** Hlavní pracovní poměr (HPP). */
  HlavniPracovniPomer = "hpp",
}
